var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/whatsapp_share.e15cf2da.png","uri@2x": __webpack_public_path__ + "static/media/whatsapp_share.28ecca7b.png","uri@3x": __webpack_public_path__ + "static/media/whatsapp_share.23f6aa08.png",
    width: 48,
    height: 48
});